export const sanitizeInput = (inp) => {
  inp = inp.replace("'", "&quot");
  // inp = inp.replace('\"','&dquot');
  inp = inp.replace("=", "&equal");
  return inp;
};

export const sanitizeWhitespace = (inp) => {
  return /\s/.test(inp);
};

export const containsKey = (obj, key) => {
  return Object.keys(obj).includes(key);
};
